import React from "react";

const SimulationResultsDataTable = (props) => {
  if (props.statistic.summary === undefined) {
    return <tbody />;
  }
  return (
    <tbody className="statistic-table">
      <tr>
        <td className="statistic-table-row">
          <p>
            {"Avg. inventory: " +
              (props.statistic.summary?.avgInventory ?? 0).toFixed(1) +
              " units"}
          </p>
        </td>
        <td className="statistic-table-row">
          <p>
            {"Total demand: " +
              ((props.statistic.summary?.totalDemand ?? 0) / 1000).toFixed(2) +
              "K units"}
          </p>
        </td>
        <td className="statistic-table-row">
          <p>
            {"Total sales: $ " +
              ((props.statistic.summary?.totalSales ?? 0) / 1000).toFixed(1) +
              "K"}
          </p>
        </td>
        <td className="statistic-table-row">
          <p>
            {"Inbound costs: $ " +
              (props.statistic.summary?.inboundCosts ?? 0).toFixed(0)}
          </p>
        </td>
        <td className="statistic-table-row">
          <p>
            {"Avg. act. inv.: " +
              (props.statistic.summary?.avgActualInventory ?? 0).toFixed(2) +
              " units"}
          </p>
        </td>
      </tr>

      <tr>
        <td className="statistic-table-row">
          <p>
            {"Avg. inv. value: $ " +
              (props.statistic.summary?.avgInventoryValue ?? 0).toFixed(1)}
          </p>
        </td>
        <td className="statistic-table-row">
          <p>
            {"Total receipts: " +
              ((props.statistic.summary?.totalReceipts ?? 0) / 1000).toFixed(
                2
              ) +
              "K units"}
          </p>
        </td>
        <td className="statistic-table-row">
          <p>
            {"Total costs: $ " +
              ((props.statistic.summary?.totalCosts ?? 0) / 1000).toFixed(2) +
              "K"}
          </p>
        </td>
        <td className="statistic-table-row">
          <p>
            {"Outbound costs: $ " +
              (props.statistic.summary?.outboundCosts ?? 0).toFixed(2)}
          </p>
        </td>
        <td className="statistic-table-row">
          <p>
            {"Act. inv. value: $ " +
              (props.statistic.summary?.actualInventoryValue ?? 0).toFixed(2) +
              " units"}
          </p>
        </td>
      </tr>

      <tr>
        <td className="statistic-table-row">
          <p>
            {"Service level: " +
              ((props.statistic.summary?.serviceLevel ?? 0) * 100).toFixed(2) +
              "%"}
          </p>
        </td>
        <td className="statistic-table-row">
          <p>
            {"Total issues: " +
              ((props.statistic.summary?.totalIssues ?? 0) / 1000).toFixed(2) +
              "K units"}
          </p>
        </td>
        <td className="statistic-table-row">
          <p>
            {"Lost sales: $ " +
              ((props.statistic.summary?.lostSales ?? 0) / 1000).toFixed(2) +
              "K"}
          </p>
        </td>
        <td className="statistic-table-row">
          <p>
            {"Storage costs: $ " +
              ((props.statistic.summary?.storageCosts ?? 0) / 1000).toFixed(2) +
              "K"}
          </p>
        </td>
        <td className="statistic-table-row">
          <p>
            {"Sim/act inv.: " +
              (props.statistic.summary?.simulatedToActualInventoryRatio ?? 0) *
                100 +
              "%"}
          </p>
        </td>
      </tr>
    </tbody>
  );
};

export default SimulationResultsDataTable;
